// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"c6978d93","118":"8629d56a","153":"c7186f93","165":"ec5c9d7f","370":"2a06a2d3","393":"7ae42165","551":"bdcec43f","873":"8af96ee5","913":"dde12da2","931":"ee8dc988"}[chunkId] + ".chunk.js";
};